export enum MonitoringReasonTypeEnum {
    Compliance = 0,
    Investigation = 1
}